const ACCAuditPipeLineFilters = [
	{
		displayName: 'Draft',
		name: 'runInProgress',
		icon: 'icons8-edit',
		iconStyle: { color: '#8C8C8C' },
	},
	{
		displayName: 'Logged',
		name: 'logged',
		icon: 'icons8-document',
		iconStyle: { color: '#1890FF' },
	},
	{
		displayName: 'Pending Approval',
		name: 'waitingForApproval',
		icon: 'icons8-hourglass',
		iconStyle: { color: '#FAAD14' },
	},
	{
		displayName: 'Approved',
		name: 'approved',
		icon: 'icons8-checkmark-filled',
		iconStyle: { color: '#5B8C00' },
	},
	{
		displayName: 'Changes Applied',
		name: 'changesApplied',
		icon: 'icons8-approve',
		iconStyle: { color: '#5B8C00' },
	},
];

export default ACCAuditPipeLineFilters;
